import { ReactElement, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { KYC_REGISTRATION_COMPLETED_STATUS } from '../../../constants'
import { useEInvoicingSetup } from '../../../hooks/useEInvoicingSetup'
import { EInvoicingSetupPath } from '../../../types'
import { navigateToUploadsUrl } from '../../../utils'
import { getStepComponentMapFromPath } from '../utils'

export const StepRouter = (): ReactElement | null => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { step } = useParams<{ step: EInvoicingSetupPath }>()

  const { organization } = useUserOrganization()
  const { kycStatus, isEInvoicingEnabled, isUserAuthorizedForKYC } = useEInvoicingSetup()

  const isKycRegistrationCompleted = KYC_REGISTRATION_COMPLETED_STATUS.includes(kycStatus)

  // Redirect to uploads if KYC registration is already completed or in progress
  useEffect(() => {
    if (isKycRegistrationCompleted && organization) {
      navigateToUploadsUrl(organization, navigate)
    }
  }, [isKycRegistrationCompleted, organization, navigate])

  if (!isEInvoicingEnabled || !isUserAuthorizedForKYC || isKycRegistrationCompleted) {
    return null
  }

  return getStepComponentMapFromPath(t)[step ?? 'company-information']
}
